var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-select",
    {
      attrs: {
        label: "name",
        filterable: false,
        options: _vm.multi_edrpoг_filtered,
      },
      on: { search: _vm.onSearchname },
      scopedSlots: _vm._u([
        {
          key: "option",
          fn: function (option) {
            return [
              _c("div", { staticClass: "d-center" }, [
                _vm._v(
                  "\n            " + _vm._s(option.name) + "\n            "
                ),
                _c("small", [_vm._v(_vm._s(option.edrpou))]),
              ]),
            ]
          },
        },
      ]),
      model: {
        value: _vm.edrpou,
        callback: function ($$v) {
          _vm.edrpou = $$v
        },
        expression: "edrpou",
      },
    },
    [
      _c("template", { slot: "no-options" }, [
        _vm._v("\n        Починайте вводити назву контрагента\n    "),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }